import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/module/datarow/page', data, {
    trim: true
  })
}

// 查询所有
export function fetchAll () {
  return request.get('/module/datarow/all')
}

// 随机创建数据
export function random (moduleId) {
  return request.get(`/module/datarow/random/${moduleId}`)
}

// 创建
export function create (data) {
  return request.post('/module/datarow/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/module/datarow/updateById', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/module/datarow/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/module/datarow/delete/batch', {
    params: {
      ids
    }
  })
}
